import { Component, HostListener, inject, LOCALE_ID, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Subject, BehaviorSubject, combineLatest, debounceTime, startWith, Subscription, filter, map, lastValueFrom, Observable, switchMap, distinct, firstValueFrom } from 'rxjs';
import { FilterChip } from '../../models/filter-chip';
import { FilterChipUtilityService } from '../../services/filter-chip-utility.service';
import { CommonModule, DatePipe, formatDate, formatNumber, I18nPluralPipe, NgLocalization } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormControl, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule, MatFabButton, MatMiniFabButton } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule, provideNativeDateAdapter } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { FilterEditorComponent } from '../filter-editor/filter-editor.component';
import { TimeEntry, TimeSheet, TimesheetStatus, TimeSheetUI } from '../../models/time-entry';
import { TimesheetService } from '../../services/time-sheet.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from '../../dialogs/confirm/confirm.component';
import { NotesComponent } from '../../notes/notes.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { trigger, transition, style, animate, state, keyframes, query } from '@angular/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '../../../environments/environment';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { UsersService } from '../../services/user.service';
import { User } from '../../models/user';
import { MatCardModule } from '@angular/material/card';
import { addDays, addMonths, compareAsc, eachDayOfInterval, endOfMonth, format, getDay, isEqual, isMatch, isSameDay, parse, startOfDay, startOfMonth, startOfWeek } from 'date-fns';
import { SubmissionDateRangePreset, SubmissionsUIPreferences, UIPreference } from '../../models/ui-preferences';
import { ComponentCanDeactivate } from '../../guards/can-deactivate.guard';
import { CommunityAuthService } from '../../services/community-auth.service';
import { ColConfig, TreeGridComponent, TreeNode } from '../tree-grid/tree-grid.component';
import { TreeHeaderTemplateDirective } from '../tree-grid/tree-header-template.directive';
import { TreeCellTemplateDirective } from '../tree-grid/tree-cell-template.directive';
import { TreeFooterTemplateDirective } from '../tree-grid/tree-footer-template.directive';
import { RemindersComponent } from '../dialogs/reminders/reminders.component';
import { EffortsService } from '../../services/efforts.service';
import { ProjectsService } from '../../services/projects.service';
import { GroupsService } from '../../services/groups.service';
import { DefaultQueries } from '../../services/default-queries.service';
import { SimpleInputComponent } from '../dialogs/simple-input/simple-input.component';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TreeEmptyResultsTemplateDirective } from '../tree-grid/tree-empty-results-template.directive';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { isOfficialLeaveProject } from '../../services/official-leave.service';

type UITimeEntry = TimeEntry & { ui: { isEmpty: boolean, isSelected: boolean } };
//type SubmissionsColumns = Map<string, string>; // UPDATED: Use Map to preserve key order
//type SubmissionsValues = { [k: string]: string | number | undefined | string[] }; // UPDATED: Adjust to work with Map keys
type SubmissionsColumns = { 'timesheet': TimeSheet, 'date': string, 'hours': string, 'status': string, 'hoursByDay': { hasNotes: boolean, value: number }, 'notes': string, sortKey: string, timeEntry: TimeEntry };
type SubmissionsValues = { [k in keyof SubmissionsColumns]: SubmissionsColumns[k] | SubmissionsColumns[k][] | undefined };

@Component({
  selector: 'app-submissions',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatSelectModule,
    FormsModule,
    MatButtonModule,
    FilterEditorComponent,
    RouterModule,
    MatSortModule,
    MatPaginatorModule,
    MatButtonToggleModule,
    MatSortModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatCardModule,
    MatSlideToggleModule,
    MatSelectModule,
    TreeGridComponent,
    TreeCellTemplateDirective,
    TreeHeaderTemplateDirective,
    TreeFooterTemplateDirective,
    TreeEmptyResultsTemplateDirective,
    I18nPluralPipe,
    MatSnackBarModule,
    RemindersComponent
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './submissions.component.html',
  styleUrl: './submissions.component.scss',
  animations: [
    // trigger('detailExpand', [
    //   state('hidden', style({ opacity: '0' })),
    //   state('shown', style({ opacity: '1'})),
    //   transition('* => *', animate('225ms ease', keyframes([
    //     style({ opacity: 0, backgroundColor: 'white', offset: 0 }),
    //     style({ opacity: 1, backgroundColor: '#f16', offset: 0.5 }),
    //     style({ opacity: 0, backgroundColor: 'white', offset: 1 })
    //   ])))
    // ]),
    // trigger('fadeAnimation', [
    //   transition('* => true', [
    //     style({ height: '0px', minHeight: '0', display: 'none' }),
    //     animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '*' }))
    //   ]),
    //   transition('true => false', [
    //     style({ height: '*' }),
    //     animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '0px', minHeight: '0', display: 'none' }))
    //   ])
    // transition('true => false', [
    //     animate('500ms ease-out')
    // ])
    // ]),
  ]
})
export class SubmissionsComponent implements ComponentCanDeactivate {
  readonly isOfficialLeaveProject = isOfficialLeaveProject;
  displayedColumns = ['selection-tools', 'effort-proj', 'date', 'hours', 'status', 'actions'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(FilterEditorComponent) filterEditor!: FilterEditorComponent;
  selectedFilters: Subject<FilterChip[]> = new BehaviorSubject<FilterChip[]>([]);
  _loading = new BehaviorSubject<boolean>(false);
  isLoading = this._loading.pipe(debounceTime(environment.spinnerDelay));
  readonly authService = inject(CommunityAuthService);
  readonly locale = inject(LOCALE_ID);
  readonly filterUtility = inject(FilterChipUtilityService);
  readonly timesheetService = inject(TimesheetService);
  readonly route = inject(ActivatedRoute);
  readonly dialog = inject(MatDialog);
  readonly fb = inject(FormBuilder);
  readonly datepipe = inject(DatePipe);
  readonly usersService = inject(UsersService);
  readonly effortsService = inject(EffortsService);
  readonly projectsService = inject(ProjectsService);
  readonly deptsService = inject(GroupsService);
  readonly defaultQueries = inject(DefaultQueries);
  readonly router = inject(Router);
  readonly snackbar = inject(MatSnackBar);
  readonly hawkidBehav = new BehaviorSubject('');
  readonly chipHelpers = {
    "status": "Filters by status",
    "effort": "Filters by owner's project membership under effort",
    "project": "Filters by owner's project membership",
    "dept": "Filters by owner's indirect association with dept",
    "dept(owners)": "Filters by owner's department ownership",
    "user": "Filters by owner's information like Hawk Id, name, email, etc",
    "reportsto.hawkid": "Filters by owner's manager (strict Hawk Id)"
  };
  readonly chipPossVals: { [key: string]: string[] | ((v: string) => Promise<string[] | string[][]>) } = {
    'status': ["Submitted", "Unsubmitted", "Review", "Approved"],
    'effort': (value: string) =>
      firstValueFrom(this.effortsService.filterEfforts([{ chip: null, value }]).pipe(map((o => o.efforts.map(u => [u.key, `${u.title} (${u.key})`]))))),
    'project': (value: string) =>
      firstValueFrom(this.projectsService.filterProjects([{ chip: null, value }]).pipe(map((o => o.projects.map(u => [u.key, `${u.title} (${u.key})`]))))),
    'dept': (value: string) =>
      firstValueFrom(this.deptsService.filterGroups([{ chip: null, value }]).pipe(map((o => o.groups.map(u => [u.key, `${u.name} (${u.key})`]))))),
    'dept(owners)': (value: string) =>
      firstValueFrom(this.deptsService.filterGroups([{ chip: null, value }]).pipe(map((o => o.groups.map(u => [u.key, `${u.name} (${u.key})`]))))),
    'user': (value: string) =>
      firstValueFrom(this.usersService.filterUsers([{ chip: null, value }]).pipe(map((o => o.users.map(u => u.hawkId))))),
    'reportsto.hawkid': (value: string) =>
      firstValueFrom(this.usersService.filterUsers([{ chip: null, value }]).pipe(map((o => o.users.map(u => [u.hawkId, `${u.displayName} (${u.hawkId})`])))))
  }

  filterControl = new FormControl('');
  autoAdjustPageSize = new FormControl(true);
  // readonly dataSource = new MatTableDataSource<UITimeEntry>();
  private _filterBoxChangedSubject = new Subject<FilterChip[]>();
  private filterBoxChanged$ = this._filterBoxChangedSubject.asObservable();
  subscription: any;
  filters: FilterChip[] = [];
  totalEntries: any;
  approvedWeeks: { [ownerId: number]: { [weekStart: string]: boolean } } = {};
  rangeForm: FormGroup;
  isPrivilegedUser: boolean = false;
  hasFilterReportsTo: boolean = true;
  user?: User;
  mainFilterSubscription?: Subscription;
  allSelected: boolean = false;
  someSelected: boolean = false;
  uiPreference?: UIPreference;
  shadowCopy?: UITimeEntry[];
  tsShadowCopy?: TimeSheet[];
  notifyReviewByEmail: FormControl = new FormControl(false);
  notifyApprovedByEmail: FormControl = new FormControl(false);
  timesheets: TimeSheet[] = [];
  treeNodes: TreeNode<SubmissionsValues>[] = [];
  // UPDATED: Use Map for level-specific columns, with nested Maps
  levelColumnsByWeek: { [key: number]: Map<string, string | string[] | ColConfig> } = {
    0: new Map<string, string | string[] | ColConfig>([["label", { "key": "label", "value": "Week of", sortKey: 'date' }], ["summary", "Timesheet(s)"], ["hours", ""]]),
    1: new Map<string, string | string[] | ColConfig>([
      // ["label", ""], ["status", ""], ["approval", ""],
      ['label', { key: "label", value: "Status", hideFooter: true }],
      ['status', { key: "status", value: "Status", hideFooter: true }],
      ['approval', { key: "approval", value: "Approval", hideFooter: true }]
    ]),
    2: new Map<string, string | string[] | ColConfig>(
      [["eff-proj-label", "Effort :: Project :: Type"], ["hoursByDay", ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]], ["hours", "Totals"],
      ["timesheet-tools", { key: "timesheet-tools", value: "Approval", hideHeader: true, hideCell: true, span: 3 }]
      ]),
    3: new Map<string, string | string[] | ColConfig>([["date", { "key": "date", "value": "Date", classes: 'notes-date' }], ["time-details", "Time Details"], ["please-review", ""]])
  };
  levelColumnsByPerson: { [key: number]: Map<string, string | string[] | ColConfig> } = {
    0: new Map<string, string | string[] | ColConfig>([["label", { "key": "label", "value": "Person", sortKey: 'displayName' }], ["summary", "Timesheet(s)"], ["hours", ""]]),
    1: new Map<string, string | string[] | ColConfig>([
      ["label", "Week of"], ["status", "Status"], ["approval", "Approval"]
    ]),
    2: new Map<string, string | string[] | ColConfig>([
      ["eff-proj-label", "Effort :: Project :: Type"], ["hoursByDay", ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]], ["hours", "Totals"],
      ["timesheet-tools", { key: "timesheet-tools", value: "Approval", hideHeader: true, hideCell: true, span: 3 }]]),
    3: new Map<string, string | string[] | ColConfig>([["date", { "key": "date", "value": "Date", classes: 'notes-date' }], ["time-details", "Time Details"], ["please-review", ""]])
  };
  levelColumnsFlat: { [key: number]: Map<string, string | string[] | ColConfig> } = {
    0: new Map<string, string | string[] | ColConfig>([["label", { "key": "label", "value": "Person - Week", sortKey: 'name-then-date' }], ["status", "Timesheet"], ["approval", "Approval"]]),
    1: new Map<string, string | string[] | ColConfig>([
      ["eff-proj-label", "Effort :: Project :: Type"], ["hoursByDay", ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]], ["hours", "Totals"],
      // [ "filler", { key: "filler", value: "", hideHeader: true, hideCell: true, span: 1 } ],
      // [ "filler2", { key: "filler2", value: "", hideHeader: true, hideCell: true, span: 1 } ],
      // ["approval", { key: "approval", value: "Approval", hideHeader: true, hideCell: true, span: 1 }],
      ["timesheet-tools", { key: "timesheet-tools", value: "Approval", hideHeader: true, hideCell: true, span: 3, classes: "fade-inout" }]
    ]),
    2: new Map<string, string | string[] | ColConfig>([
      ["date", { "key": "date", "value": "Date", classes: 'notes-date' }], ["time-details", "Time Details"], ["please-review", ""]])
  };
  viewModeColumns = this.levelColumnsByWeek;
  timesheetViewMode: FormControl = new FormControl("by-week");
  userQueryStrings: [string, Params | boolean][] = [];
  dateRangePresets: { key: SubmissionDateRangePreset, label: string }[] = [
    { key: "this-week", label: "this week" },
    { key: "last-week", label: "last week" },
    { key: "this-month", label: "this month" },
    { key: "last-month", label: "last month" },
    { key: "last-3-months", label: "last 3 months" },
    { key: "since-epoch", label: "since epoch" }
  ];
  selectedDateRangePreset?: SubmissionDateRangePreset;

  constructor() {
    this.rangeForm = this.fb.group({ start: [], end: [] });
  }

  ngAfterViewInit() {
    this.authService.isImpersonated
      .pipe(switchMap(_ => this.usersService.loadCurrentUser()))
      .subscribe(user => {
        this.user = user;
        this.uiPreference = user.userUIPreference?.data ? JSON.parse(user.userUIPreference.data) : new UIPreference();
        this.userQueryStrings = [['Default', true], ...(this.uiPreference?.submissions?.savedQueryStrings ?? [])];
        this.userQueryStrings = [...new Map(this.userQueryStrings).entries()];
        console.log("user query strings", this.userQueryStrings);
        this.notifyApprovedByEmail.setValue(this.uiPreference?.submissions?.notifyAcceptedByEmail ?? false);
        this.notifyReviewByEmail.setValue(this.uiPreference?.submissions?.notifyReviewByEmail ?? false);
        this.queryParamsChanged({
          ...this.defaultQueries.compute(user)['submissions'],
          ...this.withoutDateRangeParams(this.route.snapshot.queryParams)
        });
        this.isPrivilegedUser = user.userRoles.find(ur => ["admin", "fullaccess"].find(r => r == ur?.role?.roleName?.toLowerCase())) != null;
      });
    const anyFiltersChanged = combineLatest([this.filterBoxChanged$, this.rangeForm.valueChanges, this.autoAdjustPageSize.valueChanges.pipe(startWith(true))])
      .pipe(map(([chips, rf, adjustPageSize]) => {
        const finalFilters = structuredClone(chips);
        const start = new Date(this.rangeForm.get('start')?.value);
        const end = new Date(this.rangeForm.get('end')?.value);
        // console.log("Debugging Safari", this.rangeForm.get('start'), this.rangeForm.get('end')?.value, start, end)
        if (!isNaN(<any>start))
          finalFilters.push({ chip: 'start', value: this.datepipe.transform(this.rangeForm.get('start')?.value, 'yyyy-MM-dd')! });
        if (!isNaN(<any>end))
          finalFilters.push({ chip: 'end', value: this.datepipe.transform(this.rangeForm.get('end')?.value, 'yyyy-MM-dd')! });
        if (adjustPageSize != null)
          finalFilters.push({ chip: 'adjustPageSize', value: '' + adjustPageSize });
        if (adjustPageSize === false) {
          this.paginator.pageSize = 20;
        }
        return finalFilters;
      }));
    this.mainFilterSubscription = combineLatest([
      // this.filterBoxChanged$.pipe(debounceTime(100)),
      anyFiltersChanged,
      this.sort.sortChange.pipe(startWith({ active: this.sort.active, direction: this.sort.direction }), debounceTime(100)),
      this.paginator.page.pipe(startWith({ pageSize: this.paginator.pageSize, pageIndex: this.paginator.pageIndex }), debounceTime(100)),
      this.rangeForm.valueChanges.pipe(startWith({ start: null, end: null }), debounceTime(100)),
      this.authService.isImpersonated,
      this.timesheetViewMode.valueChanges.pipe(startWith("by-week"), debounceTime(100)),
      this.autoAdjustPageSize.valueChanges.pipe(startWith(true), debounceTime(100))
    ])
      .pipe(debounceTime(200))
      .subscribe(([finalFilters, sort, paging, range, isImpers, viewMode, adjustPageSize]) => {
        this._loading.next(true);
        // console.log("paaaging", page.pageSize, page.pageIndex);
        console.log(finalFilters);
        if (viewMode == "by-person") {
          this.viewModeColumns = this.levelColumnsByPerson;
        } else if (viewMode == "by-week") {
          this.viewModeColumns = this.levelColumnsByWeek;
        } else if (viewMode == "flat") {
          this.viewModeColumns = this.levelColumnsFlat;
        }
        console.log(paging.pageSize);
        this.filterUtility.updateUrlWithFilters(finalFilters, '/submissions');
        this.subscription = this.timesheetService.fetchTimesheetsDeep(finalFilters, paging.pageSize, paging.pageIndex, sort.active, sort.direction).subscribe(resp => {
          console.log(resp);
          this._loading.next(false);
          this.filters = finalFilters;
          console.log("Recommended page size", resp.recommendedPageSize);
          if (adjustPageSize) this.paginator.pageSize = resp.recommendedPageSize;
          const expandedNodePaths = this.expandedNodePaths(this.treeNodes);
          this.treeNodes = this.buildTreeNodes(resp.timeSheets, viewMode);
          this.restoreExpandedNodes(this.treeNodes, expandedNodePaths);
          //this.dataSource.data = this.flatten(resp.timeSheets).map(te => { (<any>te).ui = {}; (<any>te).timesheet.ui = { notifyByEmail: true }; return <UITimeEntry>te; });
          this.timesheets = resp.timeSheets;
          // this.shadowCopy = structuredClone(this.dataSource.data);
          this.tsShadowCopy = structuredClone(resp.timeSheets);
          this.totalEntries = Math.abs(resp.total);
        });
      });

    this.notifyReviewByEmail.valueChanges.pipe(debounceTime(500))
      .subscribe(notifyReview => {
        if (!this.uiPreference) return;

        this.uiPreference!.submissions ??= new SubmissionsUIPreferences();
        this.uiPreference.submissions.notifyReviewByEmail = notifyReview;
        this.usersService.savePreference(this.uiPreference!, this.user!.id).subscribe(uipref => {
          console.info("Saved notify review by email pref", notifyReview);
        });
      });

    this.notifyApprovedByEmail.valueChanges.pipe(debounceTime(500))
      .subscribe(notifyAccepted => {
        if (!this.uiPreference) return;

        this.uiPreference!.submissions ??= new SubmissionsUIPreferences();
        this.uiPreference.submissions.notifyAcceptedByEmail = notifyAccepted;
        this.usersService.savePreference(this.uiPreference!, this.user!.id).subscribe(uipref => {
          console.info("Saved notify accepted pref", notifyAccepted);
        });
      });

    this.route.queryParams.pipe(debounceTime(50)).subscribe(this.queryParamsChanged.bind(this));
    // this.queryParamsChanged(this.route.queryParams);
  }

  setDateRangePreset(preset: SubmissionDateRangePreset, savePreference = true): void {
    preset = preset === <SubmissionDateRangePreset><unknown>"next-week" ? "last-week" : preset;
    const range = this.defaultQueries.submissionsDateRange(preset);
    this.selectedDateRangePreset = preset;
    this.rangeForm.setValue(range);

    if (!savePreference || !this.uiPreference || !this.user?.id) return;

    this.uiPreference.submissions ??= new SubmissionsUIPreferences();
    this.uiPreference.submissions.dateRangePreset = preset;
    this.usersService.savePreference(this.uiPreference, this.user.id).subscribe(() => {
      console.info("Saved submissions date range preset", preset);
    });
  }

  private hasDateRangeQueryParams(p: Params): boolean {
    return !!(p["filter.start"] || p["filter.end"] || p["filter.weekof"]);
  }

  private withoutDateRangeParams(p: Params): Params {
    const params = { ...p };
    delete params["filter.start"];
    delete params["filter.end"];
    delete params["filter.weekof"];
    return params;
  }

  private presetMatchingRange(start?: Date, end?: Date): SubmissionDateRangePreset | undefined {
    if (!start || !end) return undefined;

    return this.dateRangePresets.find(preset => {
      const range = this.defaultQueries.submissionsDateRange(preset.key);
      return isSameDay(start, range.start) && isSameDay(end, range.end);
    })?.key;
  }

  async setQuery(which: Params | boolean) {
    const isBuiltInDefault = typeof which === 'boolean' && which;
    let queryParams: Params = isBuiltInDefault ? this.defaultQueries.compute(this.user!)['submissions'] : <Params>which;
    console.log(queryParams);
    queryParams = { ...queryParams };
    if (!isBuiltInDefault) {
      delete queryParams['filter.start'];
      delete queryParams['filter.end'];
      delete queryParams['filter.weekof'];
    }
    const currentQp = await firstValueFrom(this.route.queryParams);
    for (let qp in currentQp) {
      if (!isBuiltInDefault && ['filter.start', 'filter.end'].includes(qp)) queryParams[qp] = currentQp[qp];
      if (!queryParams[qp]) queryParams[qp] = null;
    }
    const success = await this.router.navigateByUrl('/', { skipLocationChange: true }).then(_ =>
      this.router.navigate(['/submissions'], { relativeTo: this.route, queryParams, queryParamsHandling: 'merge' })
    );
  }

  addQuery() {
    this.dialog.open(SimpleInputComponent, { data: { title: 'Save current query', prompt: 'Enter a name for the current query.' } })
      .afterClosed().subscribe(r => {
        if (r) {
          const newOne = <[string, Params]>[r, this.route.snapshot.queryParams];
          const sansReplacement = <[string, Params][]>this.userQueryStrings.filter(q => q[0] !== r);
          this.userQueryStrings = [...sansReplacement, newOne];
          if (!this.uiPreference) return;

          this.uiPreference!.submissions ??= new SubmissionsUIPreferences();
          this.uiPreference.submissions.savedQueryStrings = <[string, Params][]>this.userQueryStrings.filter(uq => typeof uq[1] !== 'boolean');
          this.usersService.savePreference(this.uiPreference!, this.user!.id).subscribe(uipref => {
            this.snackbar.open(r === 'Default' ? "Replaced default filter with custom." : "Saved filter.", "Ok", { duration: 5_000, verticalPosition: 'bottom' });
            console.info("Saved updated query strings", this.userQueryStrings);
          });
        }
      })
  }

  removeQuery(name: string) {
    this.userQueryStrings = this.userQueryStrings.filter(q => q[0] !== name);
    let customDefaultRemoved = false;
    if (!this.userQueryStrings.find(uq => uq[0] === 'Default')) {
      this.userQueryStrings.unshift(['Default', true]);
      customDefaultRemoved = true;
    }
    if (!this.uiPreference) return;
    this.uiPreference!.submissions ??= new SubmissionsUIPreferences();
    this.uiPreference.submissions.savedQueryStrings = <[string, Params][]>this.userQueryStrings.filter(uq => typeof uq[1] !== 'boolean');
    this.usersService.savePreference(this.uiPreference!, this.user!.id).subscribe(uipref => {
      this.snackbar.open(customDefaultRemoved ? "Removed custom default filter." : "Removed saved filter.", "Ok", { duration: 5_000, verticalPosition: 'bottom' });
      console.info("Saved updated query strings", this.userQueryStrings);
    });
  }

  buildTreeNodes(timesheets: TimeSheet[], viewMode: "by-week" | "by-person" | "flat"): TreeNode<SubmissionsValues>[] {
    const rootNodes: TreeNode<SubmissionsValues>[] = [];
    const lookup = <any>{};
    const flattened: TreeNode<SubmissionsValues>[] = [];
    for (let ts of timesheets) {
      const dateKey = formatDate(ts.weekStart!, "yyyy-MM-dd", this.locale);
      const dateFrmt = format(ts.weekStart!, "MMM dd, yyyy");
      const personKey = ts.owner ? `${ts.owner.displayName} (${ts.owner.hawkId})` : 'Unknown User';
      let node;
      switch (viewMode) {
        case "by-person":
          let personNode = lookup[personKey];
          if (!personNode)
            personNode = lookup[personKey]
              = <TreeNode<any>>{ label: `${personKey}`, nodeKey: `person:${ts.owner?.hawkId ?? personKey}`, timesheet: ts, children: <TreeNode<any>[]>[], expanded: false, renderChildFooter: true };

          node = this.nodeFromTimesheet(ts, viewMode);
          personNode.children.push(node);
          if (!rootNodes.includes(personNode))
            rootNodes.push(personNode);
          break;
        case "by-week":
          let dateNode = lookup[dateKey];
          if (!dateNode)
            dateNode = lookup[dateKey]
              = <TreeNode<any>>{ label: `${dateFrmt}`, nodeKey: `week:${dateKey}`, timesheet: ts, children: <TreeNode<any>[]>[], expanded: false, renderChildFooter: true };

          node = this.nodeFromTimesheet(ts, viewMode);
          dateNode.children.push(node);
          if (!rootNodes.includes(dateNode))
            rootNodes.push(dateNode);
          break;
        default:
          node = this.nodeFromTimesheet(ts, viewMode);
          flattened.push(node);
          break;
      }
    }
    if (viewMode == "flat") {
      return flattened;
    }

    return rootNodes;
  }

  nodeFromTimesheet(ts: TimeSheet, viewMode: "by-week" | "by-person" | "flat"): TreeNode<SubmissionsValues> {
    let label;
    if (viewMode == "by-week") {
      label = ts.owner ? `${ts.owner.displayName} (${ts.owner.hawkId})` : 'Unknown User';
    } else if (viewMode == "by-person") {
      label = formatDate(ts.weekStart!, "MMM dd, yyyy", this.locale);
    } else {
      label = `${ts.owner ? `${ts.owner.displayName} (${ts.owner.hawkId})` : 'Unknown User'} - ${formatDate(ts.weekStart!, "MMM dd, yyyy", this.locale)}`;
    }
    const node = {
      label,
      nodeKey: `timesheet:${ts.id ?? `${ts.owner?.id ?? ts.owner?.hawkId ?? 'unknown'}:${formatDate(ts.weekStart!, "yyyy-MM-dd", this.locale)}`}`,
      date: ts.weekStart,
      hours: '' + ts.timeEntries?.reduce((acc, cur) => acc + (cur.recordedTime ?? 0), 0),
      status: ts.status,
      expanded: false,
      renderChildHeader: true,
      renderChildFooter: true,
      timesheet: ts,
      children: [] as TreeNode<SubmissionsValues>[]
    } as unknown as TreeNode<SubmissionsValues>;
    const groupings = this.groupify(ts.timeEntries!);
    const endDay = addDays(ts.weekStart!, 6); // 6 days after startDay
    const daysArray = eachDayOfInterval({ start: ts.weekStart!, end: endDay });
    // console.log("daysArray", daysArray);
    for (let group in groupings) {
      const hoursGrouping = groupings[group];
      const proj = hoursGrouping[0].project;
      const effort = proj?.effort;
      const tt = hoursGrouping[0].timeType;
      const child = <any>{
        date: ts.weekStart,
        label: `${effort?.title} :: ${proj?.title}`,
        nodeKey: `entry-group:${hoursGrouping[0].projectId}:${hoursGrouping[0].timeTypeId}`,
        timeType: tt?.name,
        hours: '' + hoursGrouping.reduce((acc, cur) => acc + (cur.recordedTime ?? 0), 0),
        hoursByDay: daysArray.map(d => {
          const entry = hoursGrouping.find(e => isSameDay(e.dateEntry!, d));
          return {
            value: entry?.recordedTime ?? 0,
            isImported: isOfficialLeaveProject(proj),
            hasNotes: !!entry?.notes,
            notes: entry?.notes
          };
        }),
        status: ts.status,
        timesheet: ts,
        expanded: false,
        renderChildHeader: true,
        //renderHeader: true,
        children: hoursGrouping.map(h => <TreeNode<SubmissionsValues>>{
          label: format(h.dateEntry!, "EEEE, do MMMM"), hours: formatNumber(h.recordedTime ?? 0, 'en-US', '1.0-2'),
          notes: h.notes,
          timeEntry: h,
          timesheet: ts
        }) as TreeNode<SubmissionsValues>[]
      };
      node.children!.push(<any>child);
    }
    return node;
  }

  expandedNodePaths(nodes: TreeNode<SubmissionsValues>[], parents: string[] = []): Set<string> {
    const expandedPaths = new Set<string>();
    for (const node of nodes) {
      const path = [...parents, this.nodeKey(node)].join('|');
      if (node.expanded) {
        expandedPaths.add(path);
      }
      if (node.children?.length) {
        for (const childPath of this.expandedNodePaths(node.children, [...parents, this.nodeKey(node)])) {
          expandedPaths.add(childPath);
        }
      }
    }
    return expandedPaths;
  }

  restoreExpandedNodes(nodes: TreeNode<SubmissionsValues>[], expandedPaths: Set<string>, parents: string[] = []) {
    for (const node of nodes) {
      const path = [...parents, this.nodeKey(node)].join('|');
      node.expanded = expandedPaths.has(path);
      if (node.children?.length) {
        this.restoreExpandedNodes(node.children, expandedPaths, [...parents, this.nodeKey(node)]);
      }
    }
  }

  private nodeKey(node: TreeNode<SubmissionsValues>): string {
    return node.nodeKey ?? node.label;
  }

  groupify(entries: TimeEntry[]) {
    return entries?.reduce((acc, cur) => {
      const key = `${cur.projectId}:${cur.timeTypeId}`;
      if (!acc[key]) acc[key] = [];
      acc[key].push(cur);
      return acc;
    }, <{ [key: string]: TimeEntry[] }>{});
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.mainFilterSubscription?.unsubscribe();
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
    console.debug("Checking if we can navigate away...");
    for (let ts of this.timesheets ?? []) {
      const shadow = this.tsShadowOf(ts);
      if (!shadow) continue;
      if (shadow.status != ts.status) {
        console.debug("shadow status !=", shadow?.status, ts.status);
        return false;
      }
      if (shadow?.reviewerComments != ts.reviewerComments) {
        console.debug("shadow comments !=", shadow?.reviewerComments, ts.status);
        return false;
      }
    }
    return true;
  }

  shadowOf(entry: UITimeEntry) {
    return this.shadowCopy?.find(c => c.id == entry.id);
  }

  flatten(timesheets: TimeSheet[]) {
    const flattened = timesheets
      .flatMap(ts => {
        const entries = ts.timeEntries?.length ? ts.timeEntries! : [<UITimeEntry>{ ui: { isEmpty: true } }];
        entries?.map(e => { e.timesheet = ts; });
        // console.log(entries);
        return entries;
      })
      .map(te => {
        te.timesheet!.timeEntries = <any>[];
        return te;
      });
    return flattened;
  }

  isReview(node: TreeNode<SubmissionsColumns>, index: number): boolean {
    const child = node.children?.filter(c => getDay(c.timeEntry!.dateEntry!) == index);
    return child?.length ? child[0].timeEntry!.isPleaseReview ?? false : false;
  }

  toggleReview(node: TreeNode<SubmissionsColumns>, index: number) {
    const child = node.children?.filter(c => getDay(c.timeEntry!.dateEntry!) == index);
    if (child?.length) {
      const te = child[0].timeEntry!;
      if (isOfficialLeaveProject(te.project)) return;
      te.isPleaseReview = !te.isPleaseReview;
    }
  }

  queryParamsChanged(p: Params) {
    // console.log("Query params changed", p);
    const previousStart = this.rangeForm.get("start")?.value;
    const previousEnd = this.rangeForm.get("end")?.value;
    const filters = [];
    if (p["filter.status"]) filters.push({ chip: 'status', value: p["filter.status"] });
    if (p["filter.not.status"]) filters.push({ chip: 'status', value: p["filter.not.status"], isNegated: true })
    if (p["filter.effort"]) filters.push({ chip: 'effort', value: p["filter.effort"] });
    if (p["filter.project"]) filters.push({ chip: 'project', value: p["filter.project"] });
    if (p["filter.dept"]) filters.push({ chip: 'dept', value: p["filter.dept"] });
    if (p["filter.dept(owners)"]) filters.push({ chip: 'dept(owners)', value: p["filter.dept(owners)"] });
    if (p["filter.user"]) filters.push({ chip: 'user', value: p["filter.user"] });
    if (p["filter.reportsto.hawkid"]) filters.push({ chip: "reportsto.hawkid", value: p["filter.reportsto.hawkid"] });
    if (p["filter.adjustPageSize"]) this.autoAdjustPageSize.setValue(p["filter.adjustPageSize"] === 'true');
    if (p["filter.start"]) {
      const start = parse(p["filter.start"], "yyyy-MM-dd", new Date());
      this.rangeForm.get("start")?.setValue(start);
    } else if (p["filter.weekof"]) {
      const formats = ['yyyy-MM-dd', 'yyyy/MM/dd'];
      const start = startOfWeek(parse(p["filter.weekof"], formats.find(f => isMatch(p["filter.weekof"], f)) ?? formats[0], new Date()));
      const end = addDays(start, 6);
      this.rangeForm.get("start")?.setValue(start);
      this.rangeForm.get("end")?.setValue(end);
    } else {
      const defaultParams = this.user ? this.defaultQueries.compute(this.user)['submissions'] : undefined;
      if (defaultParams?.["filter.start"]) {
        const start = parse(defaultParams["filter.start"], "yyyy-MM-dd", new Date());
        this.rangeForm.get("start")?.setValue(start);
      } else {
        const tksEpoch = new Date(2025, 6 - 1, 29);
        const start = startOfDay(tksEpoch);
        this.rangeForm.get("start")?.setValue(start);
      }
    }
    if (p["filter.end"]) {
      const end = parse(p["filter.end"], "yyyy-MM-dd", new Date());
      this.rangeForm.get("end")?.setValue(end);
    } else {
      const defaultParams = this.user ? this.defaultQueries.compute(this.user)['submissions'] : undefined;
      if (defaultParams?.["filter.end"]) {
        const end = parse(defaultParams["filter.end"], "yyyy-MM-dd", new Date());
        this.rangeForm.get("end")?.setValue(end);
      }
    }
    if (this.hasDateRangeQueryParams(p)) {
      this.selectedDateRangePreset = this.presetMatchingRange(this.rangeForm.get("start")?.value, this.rangeForm.get("end")?.value);
    }

    if (p["filter.keywords"]) filters.push({ chip: null, value: p["filter.keywords"] });
    const aDiff = filters.find(f => { const existing = this.filters.find(f2 => f2.chip == f.chip); return !existing || existing.value != f.value; });
    const currentStart = this.rangeForm.get("start")?.value;
    const currentEnd = this.rangeForm.get("end")?.value;
    const dateDiff =
      (!!previousStart !== !!currentStart)
      || (!!previousEnd !== !!currentEnd)
      || (previousStart && currentStart && !isSameDay(previousStart, currentStart))
      || (previousEnd && currentEnd && !isSameDay(previousEnd, currentEnd));
    // console.log("Filter diffs", filters, this.filters, aDiff);
    if (!aDiff && !dateDiff) {
      return;
    }
    this.paginator.firstPage();
    this.filters = filters;
    this.selectedFilters.next(filters);
    this.updateFilters(filters);
  }

  updateFilters(filters: FilterChip[]) {
    this._loading.next(true);
    this.selectedFilters.next(filters);
    this._filterBoxChangedSubject.next(filters);
  }

  filterChange(filters: FilterChip[]): void {
    console.log("Filter changed", filters);
    this.hasFilterReportsTo = !!filters.find(f => f.chip == "reportsto.hawkid");
    this._filterBoxChangedSubject.next(filters);
  }

  // updateTimesheetApproval(t: TimeSheet, val: string) {
  //   if (val == TimesheetStatus.Approved) {
  //     t.status = <TimesheetStatus>val ?? this.tsShadowOf(t)?.status;
  //     for (let entry of this.timesheets.filter(e => e.timesheet?.id === t.id)) {
  //       entry.isPleaseReview = false;
  //     }
  //   }
  // }

  tsShadowOf(ts: TimeSheet) {
    return this.tsShadowCopy?.find(c => c.id == ts.id);
  }

  updateApproval(entry: TreeNode<SubmissionsColumns>, val: string) {
    if (val == TimesheetStatus.Approved) {
      this.resetTimesheetChoice(entry, TimesheetStatus.Approved);
    }
    entry.expanded = true;
  }

  resetTimesheetChoice(entry: TreeNode<SubmissionsColumns>, status?: TimesheetStatus) {
    const t = entry.timesheet!;
    t.status = status ?? this.tsShadowOf(t)?.status;
    for (let entry of t.timeEntries!) {
      entry.isPleaseReview = false;
    }
    entry.expanded = false;
  }

  setCurrentMonth() {
    const today = new Date();
    this.rangeForm.get('start')?.setValue(startOfMonth(today));
    this.rangeForm.get('end')?.setValue(endOfMonth(today));
    // this.uiPreference.
  }

  setPreviousMonth() {
    const today = addMonths(new Date(), -1);
    this.rangeForm.get('start')?.setValue(startOfMonth(today));
    this.rangeForm.get('end')?.setValue(endOfMonth(today));
  }

  // totalHours(timesheet: TimeSheet) {
  //   const total = this.dataSource.data.filter(te => te.timesheet?.weekStart == timesheet?.weekStart && te.timesheet?.owner?.id == timesheet?.owner?.id).reduce((total, cur) => (cur.recordedTime ?? 0) + total, 0);
  //   return total;
  // }

  totalForDay(node: TreeNode<SubmissionsValues>, dayi: number) {
    const total = node.children?.reduce((acc, cur) => {
      const hoursByDay = <{ hasNotes: boolean, value: number }[]>cur.hoursByDay;
      return acc + (hoursByDay?.[dayi]?.value ?? 0);
    }, 0) ?? 0;
    return total;
  }

  // isWeekRejected(week: string, ownerId: number) {
  //   return !!this.approvedWeeks[ownerId] && this.approvedWeeks[ownerId][week] !== undefined && !this.approvedWeeks[ownerId][week];
  // }

  // isNextUserTimesheet(i: number) {
  //   if (i == 0) return true;
  //   return this.dataSource.data[i - 1]?.timesheet?.owner?.id !== this.dataSource.data[i]?.timesheet?.owner?.id || this.dataSource.data[i - 1]?.timesheet?.weekStart !== this.dataSource.data[i]?.timesheet?.weekStart;
  // };

  // isNextUserTimesheetBound = this.isNextUserTimesheet.bind(this);

  // isLastTimesheetRow = ((i: number) => {
  //   if (i == this.dataSource.data.length - 1) return true;
  //   const isLast = this.dataSource.data[i + 1].timesheet?.owner?.id !== this.dataSource.data[i].timesheet?.owner?.id || this.dataSource.data[i + 1].timesheet?.weekStart !== this.dataSource.data[i].timesheet?.weekStart;
  //   return isLast;
  // }).bind(this);

  // isApprovalDefined(row: TimeEntry) {
  //   const ownerId = row.timesheet?.owner?.id ?? 0;
  //   const week = row.timesheet?.weekStart ?? '';
  //   console.log("recomputing", week, ownerId);
  //   return this.approvedWeeks[ownerId] && this.approvedWeeks[ownerId][week] !== undefined
  // }

  saveChoice(ts: TimeSheet) {
    const clone = structuredClone(ts);
    delete clone.officialLeave;
    delete clone.officialLeaveUnavailable;
    clone.timeEntries = [];
    //console.log(ts.timeEntries);
    for (let entry of ts.timeEntries!) {
      if (isOfficialLeaveProject(entry.project)) continue;
      clone.timeEntries.push({ id: entry.id, isPleaseReview: entry.isPleaseReview, timeTypeId: undefined });
    }
    //console.log(typeof this.notifyReviewByEmail.value);
    this.timesheetService.setTimesheetStatus(clone, clone.status == "Review" ? this.notifyReviewByEmail.value : this.notifyApprovedByEmail.value);
  }

  // openNotesDialog(notes: string) {
  //   this.dialog.open(NotesComponent, { width: '400px', data: { notes, readonly: true } });
  // }

  // clearCaution() { }
  // addUsersOwnFilter() {
  //   const reportsTo = <FilterChip>{ chip: 'reportsto.hawkid', value: this.user?.hawkId };
  //   const filters = this.filters.filter(f => f.chip !== reportsTo.chip).concat(reportsTo);
  //   console.log(filters);
  //   this.updateFilters(filters);
  // }

  sendReminders() {
    const filterPopulation = this.timesheets
      .map(t => t.owner)
      .filter((item, i, arr) => arr.findIndex(a => a!.hawkId === item!.hawkId) === i);
    const reportsPopulation = this.user?.reports ?? [];
    this.dialog.open(RemindersComponent, {
      width: '800px',
      data: { filterPopulation, reportsPopulation, startDate: this.rangeForm.get('start')?.value, endDate: this.rangeForm.get('end')?.value, user: this.user }
    });
    // const people = this.timesheets
    //   .filter(d => d.ui!.isSelected || !!d.owner?.email?.trim())
    //   .map(te => te.owner!)
    //   .reduce((acc, cur) => { if (acc.filter(a => a.email == cur.email).length == 0) acc.push(cur); return acc; }, <User[]>[]);
    // const mails = people.map(p => p.email);
    // const body = this.applyTemplateVariables(this.reminderBodyDefaults[this.whichTemplate], people);
    // const subject = this.applyTemplateVariables(this.reminderSubjectDefaults[this.whichTemplate], people);
    // const link = `mailto:${mails.join(";")}?subject=${subject}&body=${body}`;
    // window.location.href = link;
  }


  // pinFilter() {
  //   if (! this.uiPreference) return;

  //   this.uiPreference.submissions
  //   this.usersService.savePreference(this.uiPreference!, this.user!.id).subscribe(uipref => {
  //     console.info("Saved displayedColumns preference.");
  //   });
  // }

  clear() {
    this.filterEditor.clear();
  }

  startExport() {
    this.timesheetService.downloadCsv(this.filters, this.paginator.pageSize, this.paginator.pageIndex, this.sort.active, this.sort.direction);
  }
}
